// reducers/products.reducer.ts
import { Action, createReducer, on } from '@ngrx/store';
import { DashboardStatisticsTracking, ModernDashboardStats } from '../../../../models/learmo-dashboard';
 import { SessionActions } from '../user/auth/auth.actions';
import { DashboardTrackingActions, ModernDashboardTrackingActions } from './dashboard-tracking.actions';

export interface DashboardState {
  modernDashboardTracking:ModernDashboardStats | null;
  modernDashboardTrackingLoaded: boolean;
  modernDashboardTrackingError: any;
  // Old
  dashboardTracking: DashboardStatisticsTracking | null;
  dashboardTrackingLoaded: boolean;
  dashboardTrackingError: any;
}

const initialState: DashboardState = {
  modernDashboardTracking: null,
modernDashboardTrackingError: null,
modernDashboardTrackingLoaded: null,

  dashboardTracking: null,
  dashboardTrackingLoaded: false,
  dashboardTrackingError: null,
  
};

export const dashboardTrackingReducer = createReducer(
  initialState,
  on(DashboardTrackingActions.load, (state) => ({ ...state, loaded: false, error: null })),
  on(DashboardTrackingActions.loadSuccess, (state, { dashboardTracking }) => {

    return {
    ...state,
    dashboardTracking,
    dashboardTrackingLoaded: true,
    dashboardTrackingError: null,
  }}

  ),
  on(DashboardTrackingActions.loadFailure, (state, { error }) => {
    if (typeof error !== 'string') {
      return state;
    }

    return { ...state, dashboardTrackingError: error, dashboardTrackingLoaded: false };
  }),




  // Modrn
  on(ModernDashboardTrackingActions.load, (state) => ({ ...state, loaded: false, error: null })),
  on(ModernDashboardTrackingActions.loadSuccess, (state, { dashboardTracking }) => {

    return {
    ...state,
    modernDashboardTracking: dashboardTracking,
    modernDashboardTrackingLoaded: true,
    modernDashboardTrackingError: null,
  }}

  ),
  on(ModernDashboardTrackingActions.loadFailure, (state, { error }) => {
    if (typeof error !== 'string') {
      return state;
    }

    return { ...state, modernDashboardTrackingError: error, modernDashboardTrackingLoaded: false };
  }),


  on(SessionActions.forget, (state) => initialState)
);
